import { runInAction } from 'mobx';
import { requestPost } from '../../../services/real.backend';
import usersStorage from '../../../pages/Users/usersStorage';

export default function restoreUser(id) {
  const userIDs = {
    users: [],
  };
  if (typeof id === 'string') userIDs.users.push(id);
  if (typeof id === 'number') userIDs.users.push(id);
  if (id instanceof Array) userIDs.users = id;
  return requestPost('/api/users/restore', userIDs)
    .then((resp) => {
      if (resp && resp.users) {
        runInAction(() => {
          resp.users.map((user) => {
            const found = usersStorage.users.findIndex((u) => u.id == user);
            if (found >= 0) {
              usersStorage.users[found].deleted_at = null;
            }
          });
          usersStorage.users = [...usersStorage.users];
          // usersStorage.setCurrentUser(null);
        });
      }
    })
    .catch((e) => {});
}
